/* global LibShopgateClient */

// Don't use LibShopgateClient as import because this script is also used on MW

(function($) {

	var _paymentButtonRequestRunning = false;

	$.fn.shopgateMasterPassButton = function(options) {
		var defaults = {},
			calledByApp = checkClientIsShopgateApp();

		options = $.extend(true, {}, defaults, options);

		return this.each(function() {
			var $paymentButton = $(this),
				buttonIsLocked = $paymentButton.hasClass('disabled');

			function _onClick() {
				// The MasterPass button is currently locked - do nothing
				if (buttonIsLocked) {
					return false;
				}

				// Check in which context the button was clicked and proceed with the related steps
				if (calledByApp) {
					SGWebStorage.Get('masterPass', function(data) {
						_proceedAsApp(data !== null);
					});

				} else {
					_proceedAsWeb(options.session);
				}
			}

			// Take care that the click listener is only added once to the payment button.
			// We had situations where the plugin was executed multiple times for the same button which
			// caused multiple identical requests for just one button click.
			// In combination with the _paymentButtonRequestRunning variable this situation shouldn't happen again :-P
			if (!$paymentButton.data('paymentPluginExecuted')) {
				$paymentButton.off('click.masterPassPaymentButton').on('click.masterPassPaymentButton', _onClick).data('paymentPluginExecuted', true);
			}

			/**
			 * Executes the steps that are necessary when the user clicked the MasterPass button in app context
			 *
			 * @param {boolean} isSessionActive Tells a MasterPass session is currently active
			 * @private
			 */
			function _proceedAsApp(isSessionActive) {
				if (isSessionActive) {
					// The user is already logged in via MasterPass, so we can redirect him to the checkout
					SGAction.popTabToRoot({targetTab: 'cart'});
					SGAction.broadcastEvent({event:'reloadCart'});
					SGAction.openPage({src: 'sgapi:checkout', targetTab: 'cart'});
				} else {
					// The user isn't logged in via MasterPass so we redirect him to the trampoline within the in app browser
					var openPageParams = {
						src: options.requestTokenUrl,
						emulateBrowser: true
					};

					// In iOS we can use the url navigation bar for MasterPass. Since there
					// is an issue at Android that causes a wrong URL within the address bar, the default one will be used.
					if (LibShopgateClient.isAndroid()) {
						openPageParams.navigationBarParams = {
							type: 'in-app-browser-default'
						};
					} else {
						openPageParams.navigationBarParams = {
							type: 'in-app-browser-url'
						};
					}

					SGAction.openPage(openPageParams);
				}
			}

			/**
			 * Executes the steps that are necessary when the user clicked the MasterPass button in web context
			 * @private
			 */
			function _proceedAsWeb(isSessionActive) {
				if (isSessionActive) {
					// The user is already logged in via MasterPass, so we can redirect him to the checkout
					openUrl({
						src: 'checkout'
					});
				} else {

					if (_paymentButtonRequestRunning) {
						return false;
					}

					_paymentButtonRequestRunning = true;

					$.shopgate.ajax({
						type: "POST",
						url: options.requestTokenUrl,
						beforeSend: function(jqXHR, settings) {
							$(document).trigger('shopgateFramework.waitingIndicator.show');
						},
						success: function(requestTokenData, textStatus, jqXHR) {
							if (!requestTokenData.success) {
								window.location = options.cancelCallback;
							} else {
								new MasterPass.client.checkout({
									requestToken: requestTokenData.data.requestToken,
									callbackUrl: options.callbackUrl,
									merchantCheckoutId: requestTokenData.data.merchantCheckoutId,
									allowedCardTypes: options.allowedCardTypes,
									cancelCallback: options.cancelCallback,
									suppressShippingAddressEnable: options.suppressShippingAddressEnable,
									loyaltyEnabled: options.loyaltyEnabled,
									allowedLoyaltyProgram: options.allowedLoyaltyPrograms,
									requestBasicCheckout: options.requestBasicCheckout,
									version: options.version
								});
							}
							$(document).trigger('shopgateFramework.waitingIndicator.show');
						},
						complete: function() {
							_paymentButtonRequestRunning = false;
						}
					});
				}
			}
		});
	};

})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-master-pass.js